<div class="mobileFlexDates__cont {{animation}} animated">
  <ng-container *ngIf="isLoadingFlexDates$ | async; else mobileFlexDates">
    <app-flex-dates-loader></app-flex-dates-loader>
  </ng-container>
</div>

<ng-template #mobileFlexDates>
  <div class="mobileFlexDates__header">
    <app-header-results
      [dsHeaderConfig]="dsHeaderConfig"
      [parameters]="headerParams$ | async"
      (widgetClicked)="close()">
    </app-header-results>
    <div class="mobileFlexDates__header-title-cont">
      <app-ds-typography
        [text]="'FLIGHT_RESULTS_MODULE.FLEX_DATES.PRICES_IN_FLEX_DATES' | transloco"
        [size]="fontSize.RG"
        [color]="fontColor.Primary"
        [fontFamily]="fontFamily.SemiBold">
      </app-ds-typography>
      <app-ds-typography
        [text]="'FLIGHT_RESULTS_MODULE.FLEX_DATES.FIND_BEST_PRICE' | transloco"
        [size]="fontSize.XXXS"
        [color]="fontColor.Secondary">
      </app-ds-typography>
    </div>
    <div class="mobileFlexDates__header-title-box" *ngIf="isRoundTrip">
      <div class="mobileFlexDates__header-content-box" *ngFor="let slide of slides; index as i">
        <app-ds-chip-action
          [label]="slide.Title"
          [icon]="slide.Icon"
          [chipStatus]="getChipStatus(slide.Active)"
          (clickEvent)="goToSlide(i)">
        </app-ds-chip-action>
        <app-ds-typography
          [size]="fontSize.XXXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.SemiBold"
          [text]="slide.SubTitle">
        </app-ds-typography>
      </div>
    </div>
  </div>

  <div class="mobileFlexDates__content-slide" #content [class.scroll-snap]="!animationRunning" (scroll)="onScroll()">
    <ng-container *ngIf="isRoundTrip; else oneWay">
      <div class="mobileFlexDates__content-slide-box-container" #boxContainer>
        <ng-container *ngIf="getTableData$(CHEAPEST_DATES) | async as dataTable">
          <app-ds-table-title
            [data]="dataTable"
            (selected)="selectedColumnAndRow($event, CHEAPEST_DATES)">
          </app-ds-table-title>
          <ng-container *ngIf="!(byPrice$ | async)?.length">
            <app-empty-flex-dates></app-empty-flex-dates>
          </ng-container>
        </ng-container>
      </div>
      <div class="mobileFlexDates__content-slide-box-container">
        <ng-container *ngIf="getTableData$(KEEP_ARRIVAL) | async as dataTable">
          <app-ds-table-title
            [data]="dataTable"
            (selected)="selectedColumnAndRow($event, KEEP_ARRIVAL)">
          </app-ds-table-title>
          <ng-container *ngIf="!(byLengthOfStay$ | async)?.length">
            <app-empty-flex-dates></app-empty-flex-dates>
          </ng-container>
        </ng-container>
      </div>
      <div class="mobileFlexDates__content-slide-box-container">
        <ng-container *ngIf="getTableData$(SAME_DURATION) | async as dataTable">
          <app-ds-table-title
            [data]="dataTable"
            (selected)="selectedColumnAndRow($event, SAME_DURATION)">
          </app-ds-table-title>
          <ng-container *ngIf="!(byFixingDepartureAndChangingReturnTrip$ | async)?.length">
            <app-empty-flex-dates></app-empty-flex-dates>
          </ng-container>
        </ng-container>
      </div>
      <div class="mobileFlexDates__content-slide-box-container">
        <ng-container *ngIf="getTableData$(KEEP_DEPARTURE) | async as dataTable">
          <app-ds-table-title
            [data]="dataTable"
            (selected)="selectedColumnAndRow($event, KEEP_DEPARTURE)">
          </app-ds-table-title>
          <ng-container *ngIf="!(byFixingReturnAndChangingDepartureDate$ | async)?.length">
            <app-empty-flex-dates></app-empty-flex-dates>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #oneWay>
  <div class="mobileFlexDates__content-slide-box-container one-way">
    <ng-container *ngIf="getTableData$(CHEAPEST_DATES) | async as dataTable">
      <app-ds-table-title
        [data]="dataTable"
        (selected)="selectedColumnAndRow($event, CHEAPEST_DATES)">
      </app-ds-table-title>
      <ng-container *ngIf="!(byPriceOneWay$ | async)?.length">
        <app-empty-flex-dates></app-empty-flex-dates>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
